"use strict";

var ClassicWeddingInvitations = require('./ClassicWeddingInvitations');

var FloralWeddingInvitations = require('./FloralWeddingInvitations');

var RibbonWeddingInvitations = require('./RibbonWeddingInvitations');

var VellumWeddingInvitations = require('./VellumWeddingInvitations');

var LetterpressWeddingInvitations = require('./LetterpressWeddingInvitations');

module.exports = {
  ClassicWeddingInvitations: ClassicWeddingInvitations,
  FloralWeddingInvitations: FloralWeddingInvitations,
  RibbonWeddingInvitations: RibbonWeddingInvitations,
  VellumWeddingInvitations: VellumWeddingInvitations,
  LetterpressWeddingInvitations: LetterpressWeddingInvitations,
  ClassicWeddingInvitationReprints: ClassicWeddingInvitations,
  FloralWeddingInvitationReprints: FloralWeddingInvitations,
  RibbonWeddingInvitationReprints: RibbonWeddingInvitations,
  VellumWeddingInvitationReprints: VellumWeddingInvitations,
  FlatWeddingInvitationReprintsCovid: ClassicWeddingInvitations,
  LetterpressWeddingInvitationReprints: LetterpressWeddingInvitations,
  LetterpressWeddingInvitationReprintsCovid: LetterpressWeddingInvitations
};